module.exports = __webpack_public_path__ + "static/media/Review.04499018.scss";


//////////////////
// WEBPACK FOOTER
// ./src/shared/Review.scss
// module id = 147
// module chunks = 0